import axios from "../../axios.js";
import router from "../../router/index.js";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import store from "../index";
let tokenToSet;
let isRefreshingToken = false;
const login = ({ commit, dispatch }, object) => {
  window.localStorage.removeItem("loggedUser");
  window.localStorage.removeItem("loggedAdmin");
  axios
    .post("api/auth/admin", {
      password: object.password,
      login: object.login,
    })
    .then(async (response) => {
      if (response.data.message === "verification_code_was_sent") {
        const confirmed = prompt(`Podaj kod weryfikujący logowanie`, "");

        await axios
          .post(`api/auth/admin/verify`, {
            password: object.password,
            login: object.login,
            code: confirmed,
          })
          .then((response) => {
            window.localStorage.setItem("SAtoken", response.data.token);
            window.localStorage.setItem(
              "refreshToken",
              response.data.refreshToken
            );
            const expirationTime = jwt_decode(response.data.token).exp;
            const expirationTimeRefresh = jwt_decode(response.data.refreshToken)
              .exp;
            window.localStorage.setItem("expTime", expirationTime);
            window.localStorage.setItem(
              "expTimeRefresh",
              expirationTimeRefresh
            );
            Cookies.set("role", response.data.role);
            window.localStorage.setItem("role", response.data.role);
            commit("SET_USER_ROLE", response.data.role);
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${response.data.token}`;
            tokenToSet = response.data.token;
            axios.get(`api/user/start`).then((response) => {
              commit("SET_LOGGED_USER", response.data.user.user_response.phone);
              window.localStorage.setItem(
                "loggedUser",
                response.data.user.user_response.phone
              );
            });
          })
          .then(async () => {
            router.push("/users");
            commit("SET_TOKEN", tokenToSet);
            commit("LOGIN_SUCCESS", true);
            dispatch("fetchWaitingUsersCounter");
            dispatch("fetchNumberOfUnreadMessagesCounter");
            dispatch("fetchNumberOfTodoTasks");
          })
          .catch(() => {
            commit("LOGIN_SUCCESS", false);
            commit(
              "LOGIN_ERROR",
              "Brak autoryzacji. Niepoprawny kod weryfikacyjny."
            );
          });
      } else {
        window.localStorage.setItem("SAtoken", response.data.token);
        window.localStorage.setItem("refreshToken", response.data.refreshToken);
        const expirationTime = jwt_decode(response.data.token).exp;
        const expirationTimeRefresh = jwt_decode(response.data.refreshToken)
          .exp;
        window.localStorage.setItem("expTime", expirationTime);
        window.localStorage.setItem("expTimeRefresh", expirationTimeRefresh);
        Cookies.set("role", response.data.role);
        window.localStorage.setItem("role", response.data.role);
        commit("SET_USER_ROLE", response.data.role);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
        tokenToSet = response.data.token;

        axios
          .get(`api/user/start`)
          .then((response) => {
            commit("SET_LOGGED_USER", response.data.user.user_response.phone);
            const {
              phone,
              id,
              has_dod_access,
              has_pod_access,
            } = response.data.user.user_response;
            const {
              first_name,
              last_name,
            } = response.data.user.profile_response;
            const adminData = {
              id,
              phone,
              firstName: first_name,
              lastName: last_name,
              hasDodAccess: has_dod_access,
              hasPodAccess: has_pod_access,
            };
            commit("SET_LOGGED_ADMIN", adminData);
            window.localStorage.setItem(
              "loggedAdmin",
              JSON.stringify(adminData)
            );
            window.localStorage.setItem(
              "loggedUser",
              response.data.user.user_response.phone
            );
          })
          .then(async () => {
            router.push("/users");
            commit("SET_TOKEN", response.data.token);
            commit("LOGIN_SUCCESS", true);
            dispatch("fetchWaitingUsersCounter");
            dispatch("fetchNumberOfUnreadMessagesCounter");
            dispatch("fetchNumberOfTodoTasks");
          })
          .catch((error) => {
            console.log(error);
            commit("LOGIN_SUCCESS", false);
            commit(
              "LOGIN_ERROR",
              "Brak autoryzacji. Błędne dane do logowania."
            );
          });
      }
    })
    .catch(() => {
      commit("LOGIN_SUCCESS", false);
      commit("LOGIN_ERROR", "Brak autoryzacji. Niepoprawny login lub hasło.");
    });
};

const logout = ({ commit }) => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("refreshToken");
  window.localStorage.removeItem("expTime");
  window.localStorage.removeItem("expTimeRefresh");
  window.localStorage.removeItem("role");
  delete axios.defaults.headers.common["Authorization"];
  commit("SET_DOD_VIEW", false);
  commit("SET_TOKEN", null);
  commit("SET_SELECTED_USER", null);
  Cookies.set("role", null);
  commit("SET_USER_ROLE", null);
  commit("LOGIN_ERROR", null);
  // Clear the DOD-revoked flag so a different user logging in on this machine is
  // probed for their own DOD role instead of inheriting the previous user's state.
  commit("SET_DOD_ACCESS_REVOKED", false);
  router.push("/");
};

const getApplicationsVersions = async ({ commit }) => {
  const url = `api/admin/applications_versions`;
  await axios.get(url).then((res) => {
    commit("SET_APPLICATIONS_VERSIONS", res.data);
  });
};

const setExpirationTime = async ({ commit }) => {
  commit("SET_EXPIRATION_TIME", window.localStorage.getItem("expTime") - 3600);
  window.addEventListener("storage", function() {
    window.location.href =
      window.location.pathname + window.location.search + window.location.hash;
  });
};

const setNeedRefreshToken = async ({ commit }, data) => {
  commit("SET_NEED_REFRESH_TOKEN", data);
};

const refreshTokens = async () => {
  const token = window.localStorage.getItem("SAtoken");
  const refreshToken = window.localStorage.getItem("refreshToken");
  let tokenToSend;
  const expTime = window.localStorage.getItem("expTime");
  const expTimeRefresh = window.localStorage.getItem("expTimeRefresh");

  if (Date.now() <= expTime * 1000) {
    tokenToSend = token;
  } else {
    tokenToSend = refreshToken;
  }
  axios.defaults.headers.common["Authorization"] = `Bearer ${tokenToSend}`;

  if (!isRefreshingToken && expTime < new Date().getTime() / 1000) {
    if (expTimeRefresh > new Date().getTime() / 1000) {
      isRefreshingToken = true;
      axios
        .get(`/api/auth/admin/refreshTokens`)
        .then((response) => {
          window.localStorage.setItem("SAtoken", response.data.token);
          window.localStorage.setItem(
            "refreshToken",
            response.data.refreshToken
          );
          const expirationTime = jwt_decode(response.data.token).exp;
          const expirationTimeRefresh = jwt_decode(response.data.refreshToken)
            .exp;
          window.localStorage.setItem("expTime", expirationTime);
          window.localStorage.setItem("expTimeRefresh", expirationTimeRefresh);
          store.dispatch("setExpirationTime");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          isRefreshingToken = false;
        });
    }
  }
};
export default {
  login,
  logout,
  getApplicationsVersions,
  setExpirationTime,
  setNeedRefreshToken,
  refreshTokens,
};
